import { handleActions } from 'redux-actions';
import * as Actions from '@/shared/redux/constants/actions';
import { UserModel } from '@/shared/models/user.model';
import { ErrorInfo } from '@/shared/interfaces/error-info.interface';
import { RootState } from '..';
import { UserRole } from '@/shared/enums/user-role.enum';

export interface AuthStoreState extends UserModel {
  fetching: boolean;
  userLoaded: boolean;
  error: ErrorInfo | null;
  accessToken: string;
  tokenExpiresIn: number;
  permissions: string[];
  refreshToken: string;
  imageUrl?: string;
  imageLoading?: boolean;
}

export const initialState: AuthStoreState = {
  error: null,
  fetching: false,
  userLoaded: false,
  tokenExpiresIn: 0,
  userId: '',
  email: '',
  permissions: [],
  accessToken: '',
  refreshToken: '',
  name: '',
  role: [UserRole.GUEST],
  team: [],
  imageUrl: undefined,
  imageLoading: false
};

export const AuthSelectors = {
  isLoggedIn: (state: RootState) => state.auth.accessToken
};

export default handleActions<AuthStoreState>(
  {
    [Actions.REGISTER_USER_REQUEST]: (state: AuthStoreState, action: any) => {
      const { email } = action.payload;
      return {
        ...state,
        email,
        error: null,
        fetching: true
      };
    },
    [Actions.REGISTER_USER_FAILURE]: (state: AuthStoreState, action: any) => {
      return {
        ...state,
        ...action.payload,
        fetching: false,
        userLoaded: true
      };
    },
    [Actions.USER_DATA_SUCCESS]: (state: AuthStoreState, action: any) => {
      const {
        email,
        userId,
        accessToken,
        refreshToken,
        tokenExpiresIn,
        role,
        team,
        permissions,
        name
      } = action.payload;
      return {
        ...state,
        email,
        userId,
        accessToken,
        refreshToken,
        tokenExpiresIn,
        role,
        team,
        permissions,
        fetching: false,
        userLoaded: true,
        name
      };
    },
    [Actions.USER_TEAM_DATA_SUCCESS]: (state: AuthStoreState, action: any) => {
      const { team, permissions } = action.payload;
      return {
        ...state,
        team
      };
    },
    [Actions.USER_NOTIFICATION_SUCCESS]: (state: AuthStoreState, action: any) => {
      return {
        ...state,
        userNotifications: action.payload
      };
    },
    [Actions.USER_DATA_CLEANUP]: () => {
      // Reset all state including cached image URL
      return initialState;
    },
    // User Image Actions
    [Actions.USER_IMAGE_REQUEST]: (state: AuthStoreState) => {
      return {
        ...state,
        imageLoading: true
      };
    },
    [Actions.USER_IMAGE_SUCCESS]: (state: AuthStoreState, action: any) => {
      const { imageUrl } = action.payload;
      return {
        ...state,
        imageUrl,
        imageLoading: false
      };
    },
    [Actions.USER_IMAGE_FAILURE]: (state: AuthStoreState, action: any) => {
      return {
        ...state,
        imageLoading: false,
        error: action.payload
      };
    }
  },
  initialState
);
